import script from "./NewBlogModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewBlogModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewBlogModal.vue?vue&type=style&index=0&id=db9ee21e&lang=css"

const __exports__ = script;

export default __exports__